import { SectionCardInterface } from "./interfaces/SectionCardInterface";

export const PUBLIC_SECURITY_CARDS: Array<SectionCardInterface> = [
    {
        subtitle: 'subtitulo',
        title: 'titulo',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
    {
        subtitle: 'subtitulo 2',
        title: 'titulo',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
    {
        subtitle: 'subtitulo 3',
        title: 'titulo',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
    {
        subtitle: 'subtitulo 4',
        title: 'titulo',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    }
]

